(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define(factory);
	else if(typeof exports === 'object')
		exports["fast-"] = factory();
	else
		root["fast-"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _namespace = __webpack_require__(1);

	Object.defineProperty(exports, 'namespaceConfig', {
	  enumerable: true,
	  get: function get() {
	    return _namespace.namespaceConfig;
	  }
	});

	var _object = __webpack_require__(2);

	Object.defineProperty(exports, 'dynamicPropertyConfig', {
	  enumerable: true,
	  get: function get() {
	    return _object.dynamicPropertyConfig;
	  }
	});
	Object.defineProperty(exports, 'staticPropertyConfig', {
	  enumerable: true,
	  get: function get() {
	    return _object.staticPropertyConfig;
	  }
	});

	var _rootReducer = __webpack_require__(3);

	Object.defineProperty(exports, 'rootReducer', {
	  enumerable: true,
	  get: function get() {
	    return _rootReducer.rootReducer;
	  }
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.namespaceConfig = namespaceConfig;
	function namespaceAction(ns, defaultState) {
	  function creator(name, reducer) {
	    if (typeof reducer !== 'function') throw new Error('Reducer must be a function.');
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      return {
	        type: ns + '/' + name,
	        payload: args,
	        creator: creator,
	        reducer: reducer
	      };
	    };
	  }
	  creator.ns = ns;
	  creator.defaultState = defaultState;
	  creator.getState = function (state) {
	    return ns in state ? state[ns] : defaultState;
	  };
	  return creator;
	}

	var getNamespaceState = function getNamespaceState(ns, defaultState) {
	  return function (state) {
	    for (var _len2 = arguments.length, keys = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      keys[_key2 - 1] = arguments[_key2];
	    }

	    var nsState = ns in state ? state[ns] : defaultState;
	    if (keys.length === 0) return nsState;
	    var res = {};
	    for (var i = keys.length; --i >= 0;) {
	      var key = keys[i];
	      res[key] = nsState[key];
	    }
	    return res;
	  };
	};

	/**
	 * Return config for the fast redux namespace.
	 * @param {String} ns
	 * @param {*} defaultState
	 */
	function namespaceConfig(ns, defaultState) {
	  return {
	    action: namespaceAction(ns, defaultState),
	    getState: getNamespaceState(ns, defaultState)
	  };
	}

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports.staticPropertyConfig = staticPropertyConfig;
	exports.dynamicPropertyConfig = dynamicPropertyConfig;

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	/**
	 * Actions for working directly with the properties of an object stored in a
	 * state. For example object 'posts' that holds various reddits states.
	 * You can find example of usage in:
	 * examples/async/src/actions/postsByReddit.js
	 */

	var makePropertyAction = function makePropertyAction(action, propertyName) {
	  return function (name, reducer) {
	    return action(name, function (state) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }

	      return _extends({}, state, _defineProperty({}, propertyName, reducer.apply(undefined, [state[propertyName]].concat(args))));
	    });
	  };
	};

	/**
	 * Return utility functions to work directly with a single property of a parent object.
	 * Property name is provided on config stage and can't be changed during action call.
	 * Default value for the property shoult be set in a namespaceConfig
	 * @param {function} action an action that accepts the object as a state
	 * @param {function} getObjectState function to obtain state of parent namespace
	 * @param {string} propertyName name of object's property
	 * @param {*} defaultPropertyState initial value of a property
	 */
	function staticPropertyConfig(action, propertyName) {
	  var getPropertyState = function getPropertyState(state) {
	    return action.getState(state)[propertyName];
	  };
	  return {
	    propertyAction: makePropertyAction(action, propertyName),
	    getPropertyState: getPropertyState
	  };
	}

	/**
	 * Actions for working directly with the properties of an object stored in a
	 * state. For example object 'posts' that holds various reddits states.
	 * You can find example of usage in:
	 * examples/async/src/actions/postsByReddit.js
	 */

	var makeObjectAction = function makeObjectAction(action, defaultPropertyState) {
	  return function (name, reducer) {
	    return action(name, function (state, key) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }

	      var nestedState = state[key] || defaultPropertyState;
	      return _extends({}, state, _defineProperty({}, key, reducer.apply(undefined, [nestedState].concat(args))));
	    });
	  };
	};

	/**
	 * Return utility functions to work directly with properties of a parent object.
	 * Property name is provided dynamically as first argument of action.
	 * @param {function} action an action that accepts the object as a state
	 * @param {function} getObjectState function to obtain state of parent namespace
	 * @param {*} defaultPropertyState initial value of a property
	 */
	function dynamicPropertyConfig(action, defaultPropertyState) {
	  var getPropertyState = function getPropertyState(state, key) {
	    return action.getState(state)[key] || defaultPropertyState;
	  };
	  return {
	    propertyAction: makeObjectAction(action, defaultPropertyState),
	    getPropertyState: getPropertyState
	  };
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports.rootReducer = rootReducer;

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	var DEFAULT_STATE = {};

	function rootReducer(state, action) {
	  // init Redux with empty state
	  if (state === undefined) return DEFAULT_STATE;
	  var creator = action.creator,
	      reducer = action.reducer,
	      payload = action.payload;

	  if (creator && payload && typeof reducer === 'function') {
	    // handle fast-redux action
	    var ns = creator.ns,
	        getState = creator.getState;

	    var nsState = getState(state);
	    var newNsState = reducer.apply(undefined, [nsState].concat(_toConsumableArray(payload)));
	    if (newNsState === nsState) return state; // nothing changed
	    return _extends({}, state, _defineProperty({}, ns, newNsState));
	  }
	  // return unchanged state for all unknown actions
	  return state;
	}

/***/ }
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fast-redux/dist/fast-redux.js
// module id = 7
// module chunks = 0